/**
 * The detached status poll reached its wall-clock budget while the job was
 * still non-terminal. That is the claim window ending, not a failed start.
 */
export class PollBudgetElapsedError extends Error {
  override readonly name = "PollBudgetElapsedError";

  constructor() {
    super("Polling timed out");
  }
}

export function isPollBudgetElapsedError(error: unknown): boolean {
  return error instanceof PollBudgetElapsedError;
}
